export default function reduceEntriesToDependencies(dependencies, [key, value]) {
    return [...dependencies, key, value];
}
//# sourceMappingURL=reduce-entries-to-dependencies.js.map